<agr-page [pageTitle]="pageTitle()">
  <agr-form
    [formGroup]="form"
    class="layout--padding-bottom flex--gutter-container"
    style="padding-bottom: 0"
  >
    <div class="flex--row flex--align-center">
      <mat-form-field appearance="outline" class="business-partner-backoffice__search-input">
        <input
          matInput
          formControlName="search"
          placeholder="{{ 'businessPartnerBackoffice_searchBusinessPartners' | translate }}"
          (keydown.escape)="clearSearchbox()"
          (keydown.enter)="searchBusinessPartners(true)"
        />

        <button mat-icon-button matSuffix (click)="clearSearchbox()" type="button">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
      <div class="spacing--margin-bottom spacing--margin-left">
        <button
          mat-flat-button
          matSuffix
          (click)="searchBusinessPartners(true)"
          color="primary"
          type="submit"
        >
          <mat-icon>search</mat-icon>
          {{ 'businessPartnerBackoffice_searchBusinessPartnersButton' | translate }}
        </button>
      </div>
    </div>
  </agr-form>

  <div [hidden]="dataSource.data.length === 0">
    <h2 class="text--h2 text--bold">{{ 'businessPartnerBackoffice' | translate }}</h2>

    <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" matSortDirection="desc">
      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef>{{
          'businessPartnerBackoffice_type' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.type }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>{{
          'businessPartnerBackoffice_name' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.name }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="street">
        <mat-header-cell *matHeaderCellDef>{{
          'businessPartnerBackoffice_street' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.street }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="postalCode">
        <mat-header-cell *matHeaderCellDef>{{
          'businessPartnerBackoffice_postalCode' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.postalCode }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="ubn">
        <mat-header-cell *matHeaderCellDef>{{
          'businessPartnerBackoffice_ubn' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.ubn }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="brs">
        <mat-header-cell *matHeaderCellDef>{{
          'businessPartnerBackoffice_brs' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.brs }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="oneSap">
        <mat-header-cell *matHeaderCellDef>{{
          'businessPartnerBackoffice_oneSap' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.oneSap }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="sapLegacyFeedId">
        <mat-header-cell *matHeaderCellDef>{{
          'businessPartnerBackoffice_sapLegacyFeedId' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.sapLegacyFeedId }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="sapLegacyPlantId">
        <mat-header-cell *matHeaderCellDef>{{
          'businessPartnerBackoffice_sapLegacyPlantId' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.sapLegacyPlantId }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="eurofins">
        <mat-header-cell *matHeaderCellDef>{{
          'businessPartnerBackoffice_eurofins' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.eurofins }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="kat">
        <mat-header-cell *matHeaderCellDef>{{
          'businessPartnerBackoffice_kat' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.kat }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumnBusinessPartnerTable"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnBusinessPartnerTable"></mat-row>
    </mat-table>

    <mat-paginator
      #paginator
      [pageSize]="defaultPageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPage($event)"
      [length]="totalNumberOfItems()"
    ></mat-paginator>
  </div>
</agr-page>
